import regexps from '@/utils/Regexps.ts';

export default {
    required: (v: any) => !!v,
    min: (v: any, value: number) => !!v && (v.length >= value),
    emailTest: (v: any) => regexps.email.test(v),
    oneSpecial: (v: any) => regexps.oneSpecialChar.test(v),
    oneDigit: (v: any) => regexps.oneDigitChar.test(v),
    oneLower: (v: any) => regexps.oneLowerChar.test(v),
    oneUpper: (v: any) => regexps.oneUpperChar.test(v),
    noSpaces: (v: any) => regexps.noSpaces.test(v),
    phone: (v: any) => regexps.phoneRules.test(v),
    noCyrillic: (v: any) => regexps.noCyrillic.test(v),
};
